<template>
  <div class="pdf-video-show" ref="activity_scroll" @scroll="activityScroll">
    <div class="screen" @click="showBottomPosition = true" v-if="centrifugeType==1">
        <span class="title one">{{ activeTitle }}</span>
        <span class="iconfont icon-zhankai-01 class-icon-col poly-class-icon"></span>
    </div>
    <ul class="menu">
        <li @click="handleMenu('2')" :class="menuType == '2'? 'active': ''">PDF</li>
        <li @click="handleMenu('1')" :class="menuType == '1'? 'active': ''">视频</li>
    </ul>
    <!-- pdf -->
    <product-shopping v-show="menuType == '2'" :productMaterial="productMaterial" @videoChange="videoChange"></product-shopping>
    <!-- 视频 -->
    <newProVideo v-show="menuType == '1'" :productVideo="productVideo" @videoChange="videoChange"></newProVideo>
    
    <footerLine></footerLine>
    <!-- 视频播放 -->
    <video-play ref="videoPlay"></video-play>
    <van-popup
      v-model="showBottomPosition"
      position="bottom"
      :style="{ height: '40%' }"
    >
      <van-picker :columns="columns" value-key="title" title="" show-toolbar
        @cancel="showBottomPosition = false" @confirm="onConfirm"/>
    </van-popup>
  </div>
</template>

<script>
import { getProCate,getProBindList } from '@/api/centrifuge'
import productShopping from './components/product-shopping'
import newProVideo from './components/new-pro-video.vue'
import { setPurchaseNum } from '@/api/sucker'
import DPlayer from 'dplayer'
import videoPlay from '@/components/videoPlay'
import footerLine from '@/components/footerLine'
import { centrifugeRecord } from '@/libs/common'
export default {
    components: { newProVideo,productShopping,footerLine,videoPlay },
    data() {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            menuType: '2', // 1 -- 视频 2 -- pdf
            showBottomPosition: false,
            columns: [],
            page: 1,
            cid: this.$route.query.id||0,
            productVideo: [], // 绑定列表
            productMaterial: [],
            showVideo:false,
            // 选中的标题
            activeTitle: "选择您的离心机型号",
            centrifugeType:this.$route.query.centrifugeType
        }
    },
    created() {
        if(this.centrifugeType==1){
            this.getCateList()
        }else{
            this.getProList();
            let para = {
                type: 51,
                uid: this.$store.state.user.id || 0,
                action: 1,
                type_id: 0
            }
            centrifugeRecord(para);
        }
    },
    mounted() {
        if (this.$route.query.centrifugeType == 1) {
            document.title = this.menuType == 1 ? "快操指南-视频" : "快操指南-PDF";
        } else {
            document.title = this.menuType == 1 ? "操作与使用指导-视频" : "操作与使用指导-PDF";
        };
    },
    methods: {
        videoChange (item) {
            var videoUrl = JSON.parse(item.video_url)
            this.videoUrl = videoUrl[0]
            this.$refs.videoPlay.dplayerOption(`${this.cdnUrl + this.videoUrl}`)
        },
        handleMenu(type) {
            this.page = 1
            this.productVideo = []
            this.productMaterial = []
            this.menuType = type
            this.getProList()
            if (this.$route.query.centrifugeType == 1) {
                document.title = this.menuType == 1 ? "快操指南-视频" : "快操指南-PDF";
            } else {
                document.title = this.menuType == 1 ? "操作与使用指导-视频" : "操作与使用指导-PDF";
            };
        },
        getProList() {
            let para = {
                module: '2',
                type: this.menuType,
                page: this.page,
                cid: this.cid || 0
            }
            if (this.centrifugeType==1&&this.cid == this.columns[0].id) para.parent_cid = this.cid;
            getProBindList(para).then(res => {
                // console.log('绑定列表',res);
                this.$toast.clear()
                if (this.menuType == '1') {
                    this.productVideo.push(...res.data.data)
                } else {
                    this.productMaterial.push(...res.data.data)
                }
                
                this.last_page = res.data.last_page
            })
        },
        activityScroll () {
            
            var clientHeight = this.$refs.activity_scroll.clientHeight // 该容器的固定高度
            var scrollTop = this.$refs.activity_scroll.scrollTop // 滚动条距顶部的距离
            var scrollHeight = this.$refs.activity_scroll.scrollHeight // 内容的高度
            var inadvance = 25 // 距离底部距离
            this.scrollTop = scrollTop
            if (scrollHeight - scrollTop - inadvance <= clientHeight) {
                if (this.page < this.last_page) {
                    this.page++
                    this.getProList()
                }
            }
        },
        getCateList() { // 类别
            getProCate({type:7}).then(res => {
                this.columns = this.$route.query.centrifugeType == 1 ? res[0].children : res[1].children;
                this.columns.unshift({ id: this.$route.query.centrifugeType == 1 ? res[0].id : res[1].id, title: "全部" });
                this.cid = this.columns[0].id;
                this.getProList();
            })
        },
        onConfirm(item) {
            let para = {
                type: 7, // 7 离心机操作指南
                type_id: item.id,
                uid: this.$store.state.user.id || 0,
                action: 1
            }
            setPurchaseNum(para).then(res => { })// 类别人数，次数记录
            this.$toast.loading({
                message: '加载中...',
                forbidClick: true,
                duration: 0
            })
            this.activeTitle = item.title;
            this.cid = item.id
            this.page = 1
            this.productVideo = []
            this.productMaterial = []
            this.getProList()
            this.showBottomPosition = false
        }
    }
}
</script>

<style lang="scss" scoped>
.pdf-video-show {
    height: 100vh;
    overflow: auto;
}
.screen {
    width: rem(343);
    height: rem(32);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 1px solid #59C1D6;
    position: relative;
    margin: rem(16) auto 0 auto;
    
    .title {
        max-width: rem(290);
        white-space: nowrap;
        font-weight: 400;
        font-size: 14px;
        color: #59C1D6;
    }
    
    .iconfont {
        font-size: rem(15);
        color: #59C1D6;
        position: absolute;
        top: rem(8);
        right: rem(12);
        transform: rotatex(180deg);
    }
}
.menu {
    width: rem(343);
    height: rem(32);
    display: flex;
    justify-content: center;
    // align-items: center;
    border-radius: 4px;
    color: #6CC5DB;
    border: 1px solid #59C1D6;
    margin: rem(12) auto rem(26) auto;
    li {
        flex: 1;
        line-height: rem(30);
        text-align: center;
    }
    .active {
        color: #fff;
        background-color: #6CC5DB;
        border-radius: 4px;
    }
}
.pro-main {
    display: flex;
    justify-content: center;
    margin-bottom: rem(16);
    .model-pro {
        display: flex;
        justify-content: space-between;
        width: rem(343);
        margin-top: rem(12);
    li {
        display: flex;
        justify-content: space-around;
        width: rem(109);
        height: rem(30);
        line-height: rem(30);
        text-align: center;
        // background: #FFFFFF;
        color: #6CC5DB;
        background-color: #fff;
        box-shadow: 0px 1px 4px 0px rgba(51,51,51,0.5);
        border-radius: 4px;
        border: 1px solid #6C94DB;
    }
    .liActive {
        color: #fff;
        background: #6CC5DB;
    }
    .class-icon-col {
        color: $poly-color;
        // transform: rotate(180deg);
    }
    .poly-class-icon {
        text-align: right;
        transform: rotatex(180deg);
        span {
            font-size: rem(12);
        }
    }
}
}
</style>